import React from "react";
import { Handle, Position } from "reactflow";
import { FiBarChart2 } from "react-icons/fi";
import ProgressBar from "@ramonak/react-progress-bar";
import "./CustomNode.css";

interface CustomNodeProps {
  id: string;
  data: any;
  toggleNode: (nodeId: string) => void;
  expanded: boolean;
  openModal: (data: any) => void;
  userImages: Record<string, string>;
  highlighted?: boolean;
}

const getInitials = (name: string) => {
  return name?.trim()?.[0]?.toUpperCase() || "";
};


const CustomNode: React.FC<CustomNodeProps> = ({
  data,
  id,
  toggleNode,
  expanded,
  openModal,
  userImages,
}) => {
  if (!data || !data.name) {
    return (
      <div className="custom-node-container fallback-node">
        <div className="fallback-message">No data available</div>
      </div>
    );
  }

const rawBase64 = userImages?.[data.user_uid];
const isBlackImage = rawBase64 === "R0lGODlhAQABAIABAAAAAP///yH5BAEAAAEALAAAAAABAAEAAAICRAEAOw==";
const imageUrl = rawBase64 && !isBlackImage ? `data:image/jpeg;base64,${rawBase64}` : null;


  const isPeerNode = !data.self_metrics && Array.isArray(data.data);
  const selfPerf = isPeerNode
    ? data?.data?.[0]?.overall_performance ?? 0
    : data?.self_metrics?.data?.[0]?.overall_performance ?? 0;
  const teamPerf = !isPeerNode
    ? data?.vertical_metrics?.data?.[0]?.overall_performance ?? 0
    : null;

  return (
    <div className="custom-node-container">
      <Handle
        type="target"
        position={Position.Top}
        style={{
          background: "transparent",
          border: "none",
          width: "10px",
          height: "10px",
          opacity: 0,
        }}
      />

      <div className="CustomNodeuser-info">
  <div className="custom-node-avatar-fallback">
 {imageUrl ? (
  <img
    src={imageUrl}
    alt="Profile"
    className="custom-node-profile-image"
  />
) : (
  <div className="custom-node-avatar-fallback">
    {getInitials(data.name)}
  </div>
)}

</div>


        <div className="CustomNode-user-details">
          <div className="CustomNodeuser-name">{data.name}</div>
          <div className="CustomNodeuser-title">{data.job_title}</div>
          <div className="CustomNodeuser-department">{data.department}</div>
          {Array.isArray(data.children) && data.children.length > 0 && (
            <div className="CustomNodeuser-reportees">
              {data.children.length} reportee
              {data.children.length > 1 ? "s" : ""}
            </div>
          )}
        </div>

        <div
          className="dashboard-action"
          onClick={(e) => {
            e.stopPropagation();
            openModal(data);
          }}
        >
          <FiBarChart2 className="dashboard-icon" size={16} title="More Details" />
          <span className="dashboard-label">View</span>
        </div>
      </div>

      <div className="performance-box">
        <div className="performance-title">Performance</div>

        <div className="progress-row">
          <div className="progress-section">
            <div className="progress-header">
              <span className="CustomNodelabel">Self</span>
              <span className="CustomeNodepercentage">{selfPerf}%</span>
            </div>
            <ProgressBar
              completed={selfPerf}
              height="8px"
              bgColor="#1E88E5"
              baseBgColor="#e0e0e0"
              borderRadius="5px"
              labelAlignment="outside"
              isLabelVisible={false}
            />
          </div>

          {Array.isArray(data.children) && data.children.length > 0 && (
            <div className="progress-section">
              <div className="progress-header">
                <span className="label">Team</span>
                <span className="percentage">{teamPerf}%</span>
              </div>
              <ProgressBar
                completed={teamPerf}
                height="8px"
                bgColor="#43A047"
                baseBgColor="#e0e0e0"
                borderRadius="5px"
                labelAlignment="outside"
                isLabelVisible={false}
              />
            </div>
          )}
        </div>

        {Array.isArray(data.children) && data.children.length > 0 && (
          <div
            className="CustomNodeexpand-circle"
            onClick={(e) => {
              e.stopPropagation();
              toggleNode(id);
            }}
          >
            {expanded ? "–" : data.children.length}
          </div>
        )}
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        style={{
          background: "transparent",
          border: "none",
          width: "10px",
          height: "10px",
          opacity: 0,
          pointerEvents: "none",
          position: "absolute",
          zIndex: -1,
        }}
      />
    </div>
  );
};

export default CustomNode;
